import React, { useEffect, useState } from "react";
import "../assets/css/AboutUsPage.css";
import Verified_Cisco from "../assets/images/AboutPage_images/BackupMeraki is a Verified Cisco Marketplace Application.svg";
import EcoSystem_Partner_img from "../assets/images/AboutPage_images/welcome-to-nexivity-cisco-meraki.png";
import Benefits_Automation from "../assets/images/AboutPage_images/Benefits of Network Automation.svg";
import { Link, useLocation } from "react-router-dom";
import "react-international-phone/style.css";
import ReactPhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import axios from "axios";
import TurnstileWidget from "./TurnstileWidget";
const AboutUsPage = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    company: "",
    email: "",
    phone: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [statusMessage, setStatusMessage] = useState("");
  const [turnstileToken, setTurnstileToken] = useState("");
  const [turnstileKey, setTurnstileKey] = useState(0);
  const location =useLocation();

  useEffect(()=>{
    if(location.hash){
      const section = document.querySelector(location.hash);
      if(section)
      {
        section.scrollIntoView({behavior:'smooth'});
      }
    }
  },[location])

  const handleChange = (e) => {
  const { name, value } = e.target;

  setFormData((prev) => ({
    ...prev,
    [name]: value,
  }));

  setErrors((prev) => {
    const newErrors = { ...prev };

    if (name === "fullName" && value.trim() !== "") {
      delete newErrors.fullName;
    }
    if (name === "company" && value.trim() !== "") {
      delete newErrors.company;
    }
    if (name === "email") {
      if (/\S+@\S+\.\S+/.test(value)) {
        delete newErrors.email;
      }
    }
    if (name === "message" && value.trim() !== "") {
      delete newErrors.message;
    }

    return newErrors;
  });
};


  
  const validate = () => {
    const newErrors = {};
    if (!formData.fullName.trim())
      newErrors.fullName = "Full Name is required.";
    if (!formData.company.trim()) newErrors.company = "Company is required.";
    if (!formData.email.trim()) {
      newErrors.email = "Email is required.";
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(formData.email)
    ) {
      newErrors.email = "Invalid email address.";
    }
    return newErrors;
  };

  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatusMessage(""); 
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setErrors({}); 

    
    const payload = {
      full_name: formData.fullName,
      company: formData.company,
      email: formData.email,
      phone: formData.phone || "", 
      message: formData.message,
      turnstile_token: turnstileToken,
    };

    try {
      const response = await axios.post(
        "https://4jfdbhks2l.execute-api.ap-southeast-2.amazonaws.com/contact-us",
        payload,
        { headers: { "Content-Type": "application/json" } }
      );

      if (response.data.result === "Success.") {
        setStatusMessage("Form submitted successfully!");

        setFormData({
          fullName: "",
          company: "",
          email: "",
          phone: "",
          message: "",
        });
      } else if (response.data.error) {
        setStatusMessage(`Error: ${response.data.message}`);
      } else {
        setStatusMessage("Something went wrong. Please try again.");
      }
    } catch (error) {
      setStatusMessage("Server error. Please try again later.");
      console.error(error);
    }
    setTurnstileKey(turnstileKey + 1);
  };

  return (
    <section className="mian-top-section">
      <h1 className="main-heading text-center">About Us</h1>
      {/* First section verified-cicso */}
      <div className="container verified-cisco text-center d-flex">
        <div className="col-md-6 first-sec-left-img">
          <img src={Verified_Cisco} alt="verified_cisco" />
        </div>
        <div className="col-md-6 first-sec-left-content">
          <h2 className="verified-cisco-heading">
            BackupMeraki is a Verified Cisco Marketplace Application
          </h2>
          <p className="marketplace-link-para">
            BackupMeraki is proud to be an officially verified application
            available on the{" "}
            <Link
              to="https://marketplace.cisco.com/en-US/apps/426592/backup-meraki"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 underline hover:text-blue-800"
            >
              Cisco Networking App Marketplace
            </Link>
            .
          </p>
          <p>
            Our application has undergone rigorous testing and verification to
            ensure it meets the highest standards for security and performance.
            By choosing BackupMeraki, you are not just choosing a reliable
            backup solution. You are also ensuring that your data management is
            in safe hands.
          </p>
        </div>
      </div>
      {/* Second section nexivity-cisco */}
      <section className="nexivity-cisco d-flex">
        <div className="second-sec-contianer container d-flex">
          <div className="col-md-6 right-second-content ">
            <h2 className="second-sec-heading">
              Welcome to Nexivity - Cisco Meraki Ecosystem Partner!
            </h2>
            <p className="naxivity-para-wl">
              BackupMeraki is an online service brought to you by Nexivity.
            </p>
            <p className="naxivity-para-link">
              <Link
                to="https://nexivity.net/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 underline hover:text-blue-800"
              >
                Nexivity
              </Link>{" "}
              is a registered Cisco Meraki Ecosystem Partner.
            </p>
            <p className="expertise-para">
              Our core expertise is Network Automation and our mission is to run
              Networks on autopilot. We are harnessing the power of software and
              automation to make networks more agile, reliable, and secure. We
              live and breathe Network Automation. BackupMeraki is a great
              example of how we can solve a complex challenge using the power of
              automation and APIs.
            </p>
            <p className="deep-expertise-para">
              With our deep expertise in networking and intimate knowledge of
              Cisco Meraki hardware and software we are well-equipped to elevate
              your organization's network management to the next level.
            </p>
          </div>
          <div className="col-md-6 right-second-image">
            <img src={EcoSystem_Partner_img} alt="Welcome to Nexivity" />
          </div>
        </div>
      </section>
      {/* third section benefits Automation */}
      <div className="container benefits-automation d-flex">
        <div className="col-md-6 third-sec-img">
          <img src={Benefits_Automation} alt="Benefits-Automation" />
        </div>
        <div className="col-md-6 third-sec-content">
          <h2 className="third-heading text-center">
            Benefits of Network Automation.
          </h2>
          <p className="third-sec-para">
            Network Automation allows customers to enjoy a number of benefits
            such as:
          </p>
          <ul className="third-sec-ul">
            <li className="third-sec-li">
              To speed up network provisioning and deployment,
            </li>
            <li className="third-sec-li">
              To improve network operations efficiency and to greatly reduce
              MTTR (minimum time to resolution),
            </li>
            <li className="third-sec-li">
              To bring an extra layer of safety and security to the network,
            </li>
            <li className="third-sec-li">
              To extend the capabilities of the network beyond the standard
              feature set offered by networking vendors{" "}
            </li>
            <li className="third-sec-li">
              To reduce the TCO (total cost of ownership) of the network
              infrastructure,
            </li>
            <li className="third-sec-li">
              To greatly reduce compliance and regulatory risks.
            </li>
          </ul>
        </div>
      </div>
      {/* Fourth section contact us */}
      <section className="four-contact-us py-5" id="contact-us">
        <div className="container">
          <h2 className="four-sec-heading text-center mb-4">Contact Us</h2>

          <div className="row form-outer-div">
            <div className="form-cont-sec">
              <form className="p-4" onSubmit={handleSubmit}>
                
                <div className="mb-3">
                  <label className="form-label">Full Name *</label>
                  <input
                  placeholder="Your Full Name"
                    type="text"
                    name="fullName"
                    className="form-control"
                    value={formData.fullName}
                    onChange={handleChange}
                  />
                  {errors.fullName && (
                    <small className="text-danger">{errors.fullName}</small>
                  )}
                </div>

               
                <div className="mb-3">
                  <label className="form-label">Company *</label>
                  <input
                  placeholder="Your company"
                    type="text"
                    name="company"
                    className="form-control"
                    value={formData.company}
                    onChange={handleChange}
                  />
                  {errors.company && (
                    <small className="text-danger">{errors.company}</small>
                  )}
                </div>

                
                <div className="email-phone-div d-flex gap-3">
                  <div className="mb-3 flex-grow-1">
                    <label className="form-label">Email *</label>
                    <input
                    placeholder="Your email"
                      type="email"
                      name="email"
                      className="form-control"
                      value={formData.email}
                      onChange={handleChange}
                    />
                    {errors.email && (
                      <small className="text-danger">{errors.email}</small>
                    )}
                  </div>
                  <div className="mb-3 flex-grow-1">
                    <label className="form-label">Phone Number</label>
                    <ReactPhoneInput
                      country={"us"} 
                      value={formData.phone}
                      onChange={(phone) =>
                        setFormData((prev) => ({ ...prev, phone }))
                      }
                      
                      inputClass="form-control"
                      enableSearch={true}
                      placeholder="Select country & enter phone"
                    />
                  </div>
                </div>

               
                <div className="mb-3">
                  <label className="form-label">Message</label>
                  <textarea
                  placeholder="Your message"
                    name="message"
                    className="form-control"
                    rows="4"
                    value={formData.message}
                    onChange={handleChange}
                    style={{resize:"none"}}
                  ></textarea>
                </div>

                <TurnstileWidget key={turnstileKey} onToken={setTurnstileToken} />

                {statusMessage && (
                  <div
                    className={`mb-3 ${
                      statusMessage.startsWith("Error") ||
                      statusMessage.startsWith("Server")
                        ? "text-danger"
                        : "text-success"
                    }`}
                  >
                    {statusMessage}
                  </div>
                )}

                
                <button className="btn main-btn w-25" type="submit">
                  Submit
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </section>
  );
};

export default AboutUsPage;
